const required = (name: string, value: string | undefined): string => {
  if (!value) {
    console.warn(`[config] Missing ${name} — set it in .env.local`);
  }
  return value ?? "";
};

export const config = {
  authUrl: required("VITE_AUTH_URL", import.meta.env.VITE_AUTH_URL),
  migrationApiUrl: required(
    "VITE_MIGRATION_API_URL",
    import.meta.env.VITE_MIGRATION_API_URL
  ),
  campaignEnd: new Date(
    // RDT-258: campaign reopened through June 30, closes at midnight BRT on July 1st.
    import.meta.env.VITE_CAMPAIGN_END ?? "2026-07-01T00:00:00-03:00"
  ),
};
